import React from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-cards';
import './swiperCard.css';
import { EffectCards } from 'swiper/modules';
import RecentBlog from '../recentBlog/RecentBlog';

export default function SwiperCard() {
  const blogObj=[{
    src:'https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/BLOG_SECTION/blogImage01.png',
    title:'Top tips for effective budget financial planning for you.',
    content:'Small businesses improving real-time finance efficiency, reducing, providing real-time.'
    
},
{
src:'https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/BLOG_SECTION/blogImage02.png',
title:'Discover the new feature of database system',
content:'Small businesses improving real-time finance efficiency, reducing, providing real-time.',

},{
src:'https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/BLOG_SECTION/blogImage03.png',
title:'Success is our only target of kriha megam',
content:'Small businesses improving real-time finance efficiency, reducing, providing real-time.',

}]
  return (
    <>
      <div > 
      <Swiper 
        effect={'cards'}
        initialSlide={2}
        grabCursor={true}
        modules={[EffectCards]}
        className="mySwiper"
        cardsEffect={{slideShadows:false,
          perSlideOffset: 6,  
          perSlideRotate: 10
        }}
      >
        {blogObj.map((item,index)=>
        <SwiperSlide key={index}><RecentBlog {...item}/></SwiperSlide>)
        }
        
      </Swiper>
      </div>
    </>
  );
}
